import { render } from "./Callback.vue?vue&type=template&id=1413735d"
import script from "./Callback.vue?vue&type=script&lang=ts"
export * from "./Callback.vue?vue&type=script&lang=ts"
script.render = render

export default script